import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from "@mui/x-data-grid";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from "../Univ.js";
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
function DailyConsolidate() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [combinedData, setCombinedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => setStartDate(date);
    const handleEndDateChange = (date) => setEndDate(date);
    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);
    async function fetchData() {
        setIsLoading(true);
        const start = startDate ? startDate.toISOString().substring(0, 10) : "";
        const end = endDate ? endDate.toISOString().substring(0, 10) : "";
        try {
            const salesRes = await axios.get(
                `${baseUrl}all-pharm-sale/?start_date=${start}&end_date=${end}&status=1`
            );
            const grouped = {};
            salesRes.data.forEach(cur => {
                const date = cur.add_date_date;
                if (!grouped[date]) {
                    grouped[date] = {
                        total: 0,
                        paid: 0,
                        returnAmount: 0
                    };
                }
                grouped[date].total += parseFloat(cur.total || 0);
                grouped[date].paid += parseFloat(cur.paid || 0);
            });
            const returnRes = await axios.get(
                `${baseUrl}sale-return-report/?start_date=${start}&end_date=${end}&status=1`
            );
            returnRes.data.forEach(cur => {
                const date = cur.add_date_date;
                if (!grouped[date]) {
                    grouped[date] = {
                        total: 0,
                        paid: 0,
                        returnAmount: 0
                    };
                }
                grouped[date].returnAmount += parseFloat(cur.total || 0);
            });
            const finalData = Object.entries(grouped).map(([date, v]) => ({
                date,
                sales: v.total,
                paid: v.paid,
                returns: v.returnAmount,
                net: v.total - v.returnAmount
            }));
            finalData.sort((a, b) => new Date(a.date) - new Date(b.date));
            setCombinedData(finalData);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    }
    const totalSales = combinedData.reduce((a, b) => a + b.sales, 0);
    const totalPaid = combinedData.reduce((a, b) => a + b.paid, 0);
    const totalReturn = combinedData.reduce((a, b) => a + b.returns, 0);
    const netSales = totalSales - totalReturn;
    const columns = [
        {field: "date", headerName: "Date", width: 120},
        {field: "sales", headerName: "Sales", width: 120},
        {field: "paid", headerName: "Paid", width: 120},
        {field: "returns", headerName: "Return", width: 120},
        {field: "net", headerName: "Net", width: 120}
    ];
    return (
        <section className="container mt-4">

            <h3 className="text-center bg-info text-white p-2">
                Daily Consolidated Report
            </h3>

            {/* FILTER */}
            <div className="row mb-3">
                <div className="col-md-4">
                    <DatePicker selected={startDate} placeholderText="From Date" onChange={handleStartDateChange}/>
                </div>
                <div className="col-md-4">
                    <DatePicker selected={endDate} placeholderText="To Date" onChange={handleEndDateChange}/>
                </div>
            </div>

            {/* KPI */}
            <div className="row text-center mb-3">
                <div className="col-md-3">Sales<br/><h4>₹{totalSales.toFixed(2)}</h4></div>
                <div className="col-md-3">Paid<br/><h4>₹{totalPaid.toFixed(2)}</h4></div>
                <div className="col-md-3">Return<br/><h4>₹{totalReturn.toFixed(2)}</h4></div>
                <div className="col-md-3">Net<br/><h4>₹{netSales.toFixed(2)}</h4></div>
            </div>

            {/* BAR GRAPH */}
            <div style={{width: "100%", height: 380}}>
                <ResponsiveContainer>
                    <BarChart data={combinedData}>
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="date"/>
                        <YAxis/>
                        <Tooltip/>
                        <Legend/>

                        <Bar dataKey="sales" fill="#0d6efd" name="Sales"/>
                        <Bar dataKey="paid" fill="#198754" name="Paid"/>
                        <Bar dataKey="returns" fill="#dc3545" name="Returns"/>
                        <Bar dataKey="net" fill="#6f42c1" name="Net Sales"/>
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* TABLE */}
            <div style={{height: 400, width: "100%"}}>
                <DataGrid
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                    rows={combinedData.map((r, i) => ({...r, id: i + 1}))}
                    columns={columns}
                    pageSize={10}
                    slots={{toolbar: GridToolbar}}
                    autoHeight
                />
            </div>

        </section>
    );
}
export default DailyConsolidate;